import { useEffect, useState } from 'react';
import MainPage from './components/MainPage';
import AuthPage from './components/AuthPage';
import utils, { AUTH_EXPIRED_EVENT } from './utils/utils';
import { API } from './service/ProductsService';

// חייבים להתחבר כדי להשתמש באתר: בלי טוקן → AuthPage (כניסה / הרשמה).
// טוקן שפג או משתמש שנחסם → השרת מחזיר code 90, utils.requestData שולח AUTH_EXPIRED_EVENT, וחוזרים לכניסה.
const ZolBakfarApp = () => {
  const [user, setUser] = useState(() => utils.getCurrentUser());

  useEffect(() => {
    const onExpired = () => setUser(null);
    window.addEventListener(AUTH_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(AUTH_EXPIRED_EVENT, onExpired);
  }, []);

  const handleLogin = (token, loggedUser) => {
    utils.saveLogin(token, loggedUser);
    setUser(utils.getCurrentUser());
  };

  const handleLogout = async () => {
    // מבטל את הטוקן בשרת (spSignOut); מתנתקים מקומית גם אם הקריאה נכשלה
    try { await API.signOut(); } catch (e) { /* ממשיכים בניתוק */ }
    utils.clearLogin();
    setUser(null);
  };

  return (
    <div dir="rtl" lang="he">
      {user
        ? <MainPage user={user} onLogout={handleLogout} />
        : <AuthPage onLogin={handleLogin} />}
    </div>
  );
};

export default ZolBakfarApp;
